function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
var FetchHandlerStatusCode = /*#__PURE__*/ function(FetchHandlerStatusCode) {
    FetchHandlerStatusCode[FetchHandlerStatusCode["FetchError"] = -1] = "FetchError";
    FetchHandlerStatusCode[FetchHandlerStatusCode["ReadTextError"] = -2] = "ReadTextError";
    FetchHandlerStatusCode[FetchHandlerStatusCode["JsonParseError"] = -3] = "JsonParseError";
    FetchHandlerStatusCode[FetchHandlerStatusCode["TimeoutError"] = -10] = "TimeoutError";
    return FetchHandlerStatusCode;
}({});
/**
 * fetch handler
 *
 * statusCode
 * -1 = fetch error
 * -2 = read stream error
 * -3 = parse json error
 * -10 = timeout
 * @param input
 * @param requestInit
 * @param timeout in millisecond
 */ var fetchHandler = function(input, requestInit, timeout) {
    return new Promise(function(resolve) {
        var timer = setTimeout(function() {
            resolve({
                error: new Error("" + input + ": request timeout"),
                statusCode: -10,
                success: false
            });
        }, timeout);
        fetch(input, requestInit).then(function(response) {
            // cancel timer
            clearTimeout(timer);
            response.text()// transform to json object
            .then(function(raw) {
                try {
                    var parsed = JSON.parse(raw);
                    if (response.status >= 500) {
                        resolve({
                            data: parsed,
                            error: new Error(raw),
                            statusCode: response.status,
                            success: response.ok
                        });
                        return;
                    }
                    resolve({
                        data: parsed,
                        statusCode: response.status,
                        success: response.ok
                    });
                } catch (error) {
                    if (_instanceof(error, SyntaxError) || _instanceof(error, TypeError)) {
                        error.message = error + ";\n response: " + raw + ";\n statusCode: " + response.status;
                        resolve({
                            error: error,
                            statusCode: -3,
                            success: false
                        });
                        return;
                    }
                    throw error;
                }
            })// handle general error
            .catch(function(error) {
                return resolve({
                    error: error,
                    statusCode: -2,
                    success: false
                });
            });
        })// handle fetch error
        .catch(function(error) {
            // cancel timer
            clearTimeout(timer);
            resolve({
                error: error,
                statusCode: -1,
                success: false
            });
        });
    });
};

export { FetchHandlerStatusCode as F, fetchHandler as f };
